import { render, staticRenderFns } from "./AcceptInvitationPage.vue?vue&type=template&id=744759c8&scoped=true&"
import script from "./AcceptInvitationPage.vue?vue&type=script&lang=js&"
export * from "./AcceptInvitationPage.vue?vue&type=script&lang=js&"
import style0 from "./AcceptInvitationPage.vue?vue&type=style&index=0&id=744759c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744759c8",
  null
  
)

export default component.exports